var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "tab-wrap tab-wrap--lg",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('u-tabs-solid', [_c('v-tab', {
    on: {
      "click": function click($event) {
        return _vm.input(null);
      }
    }
  }, [_vm._v("전체")]), _vm._l(_vm.categories, function (category, index) {
    return _c('v-tab', {
      key: index,
      on: {
        "change": function change($event) {
          return _vm.input(category);
        }
      }
    }, [_vm._v(" " + _vm._s(category) + " ")]);
  })], 2)], 1), _c('v-row', {
    staticClass: "row--xs search--primary",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-select', {
    staticClass: "v-input--small w-100 w-md-120px",
    attrs: {
      "items": _vm.searchKeys,
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "v-input--small w-100 w-md-240px",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "placeholder": "검색어를 입력하세요.",
      "disabled": !_vm.filter.searchKey
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "h-100 w-100 min-w-md-60px",
    attrs: {
      "dark": "",
      "color": "grey"
    },
    on: {
      "click": function click($event) {
        return _vm.search();
      }
    }
  }, [_vm._v("검색")])], 1)], 1), _c('table', {
    staticClass: "board-list mt-12px mt-md-24px",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._m(0), _c('tbody', [_vm._l(_vm.fixed, function (notification, index) {
    return _c('tr', {
      key: index,
      staticClass: "board-list__notice",
      on: {
        "click": function click($event) {
          return _vm.$router.push("".concat(_vm.$route.path, "/").concat(notification._id));
        }
      }
    }, [_c('td', {
      staticClass: "board-list__txt board-list__txt--first",
      attrs: {
        "align": "center"
      }
    }, [_c('v-layout', {
      attrs: {
        "align-center": "",
        "justify-center": ""
      }
    }, [_c('v-icon', {
      staticClass: "font-size-16 font-size-md-20 mr-4px",
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-alert-circle")]), _c('span', {
      staticClass: "font-weight-bold secondary--text"
    }, [_vm._v(_vm._s(notification.category))])], 1)], 1), _c('td', {
      staticClass: "board-list__tit",
      attrs: {
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "text-truncate"
    }, [_c('span', [_vm._v(_vm._s(notification.subject))])])]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(notification.createdAt.toDate()) + " ")]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(notification.viewCount) + " ")])]);
  }), _vm._l(_vm.notifications, function (notification, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.$router.push("".concat(_vm.$route.path, "/").concat(notification._id));
        }
      }
    }, [_c('td', {
      staticClass: "board-list__txt board-list__txt--first",
      attrs: {
        "align": "center"
      }
    }, [_c('span', {
      staticClass: "font-weight-bold secondary--text"
    }, [_vm._v(_vm._s(notification.category))])]), _c('td', {
      staticClass: "board-list__tit",
      attrs: {
        "align": "center"
      }
    }, [_c('div', {
      staticClass: "text-truncate"
    }, [_c('span', [_vm._v(_vm._s(notification.subject))])])]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(notification.createdAt.toDate()) + " ")]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(notification.viewCount) + " ")])]);
  })], 2)]), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "d-none d-lg-table-header"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("구분")]), _c('th', {
    staticStyle: {
      "width": "58%"
    }
  }, [_vm._v("제목")]), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("작성일")]), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("조회")])])]);
}]

export { render, staticRenderFns }